import type { ExceptionStackFrame } from "@grafana/faro-react";

// Scripts injected by browser extensions throw errors we cannot fix. Safari
// masks their origin as webkit-masked-url://hidden/.
export const browserExtensionUrlPatterns = [
  /^webkit-masked-url:\/\//,
  /^safari-web-extension:\/\//,
  /^safari-extension:\/\//,
  /^chrome-extension:\/\//,
  /^moz-extension:\/\//,
];

export function isBrowserExtensionError(frames: ExceptionStackFrame[]) {
  return (
    frames.length > 0 &&
    frames.every((frame) =>
      browserExtensionUrlPatterns.some((pattern) =>
        pattern.test(frame.filename),
      ),
    )
  );
}
